// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"81401b53","501":"0fa90a6e","925":"18997b15"}[chunkId] + ".chunk.js";
};